"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRailgunTxidMerkleroot = exports.getLatestRailgunTxidData = exports.resetRailgunTxidsAfterTxidIndex = exports.fullResetRailgunTxidMerkletrees = exports.validateRailgunTxidOccurredBeforeBlockNumber = exports.validateRailgunTxidMerkleroot = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const core_1 = require("../core");
const validateRailgunTxidMerkleroot = (networkName, tree, index, merkleroot) => {
    const chain = shared_models_1.NETWORK_CONFIG[networkName].chain;
    return (0, core_1.getEngine)().validateHistoricalRailgunTxidMerkleroot(chain, tree, index, merkleroot);
};
exports.validateRailgunTxidMerkleroot = validateRailgunTxidMerkleroot;
const validateRailgunTxidOccurredBeforeBlockNumber = (networkName, tree, index, blockNumber) => {
    const chain = shared_models_1.NETWORK_CONFIG[networkName].chain;
    return (0, core_1.getEngine)().validateRailgunTxidOccurredBeforeBlockNumber(chain, tree, index, blockNumber);
};
exports.validateRailgunTxidOccurredBeforeBlockNumber = validateRailgunTxidOccurredBeforeBlockNumber;
const fullResetRailgunTxidMerkletrees = async (networkName) => {
    const chain = shared_models_1.NETWORK_CONFIG[networkName].chain;
    return (0, core_1.getEngine)().fullResetRailgunTxidMerkletrees(chain);
};
exports.fullResetRailgunTxidMerkletrees = fullResetRailgunTxidMerkletrees;
const resetRailgunTxidsAfterTxidIndex = async (networkName, txidIndex) => {
    const chain = shared_models_1.NETWORK_CONFIG[networkName].chain;
    return (0, core_1.getEngine)().resetRailgunTxidsAfterTxidIndex(chain, txidIndex);
};
exports.resetRailgunTxidsAfterTxidIndex = resetRailgunTxidsAfterTxidIndex;
const getLatestRailgunTxidData = async (networkName) => {
    const chain = shared_models_1.NETWORK_CONFIG[networkName].chain;
    return (0, core_1.getEngine)().getLatestRailgunTxidData(chain);
};
exports.getLatestRailgunTxidData = getLatestRailgunTxidData;
const getRailgunTxidMerkleroot = async (networkName, tree, index) => {
    const chain = shared_models_1.NETWORK_CONFIG[networkName].chain;
    return (0, core_1.getEngine)().getHistoricalRailgunTxidMerkleroot(chain, tree, index);
};
exports.getRailgunTxidMerkleroot = getRailgunTxidMerkleroot;
